<template>
    <div class="ho-list-timeline">
        <ActionList v-if="rakenneElementit.length > 1" :rakenne-elementti="rakenneElementit[0]" :ministeriot="ministeriot" :kohde-linkit="kohdeLinkit" :kohteiden-linkit="kohteidenLinkit" :liittyvat-kohde-uuids="liittyvatKohdeUuids" :valitavoite-tyypit="valitavoiteTyypit"/>

        <template v-for="tavoite in filteredRakenneElementit">
            <div :class="[rakenneElementit.length > 1 ? 'child ho-collapsible' : '', '']">
                <h3 class="heading" :id="generateIdFromElementti(tavoite)" v-if="rakenneElementit.length > 1">
                    <a :name="'ho-goal-' + tavoite.jarjestysnumero"></a>
                    <button :id="'ho-goal-' + tavoite.jarjestysnumero"
                            class="ho-collapsible-trigger opened"
                            @click="toggleCollapse"
                            :aria-controls="'ho-goal-content-' + tavoite.jarjestysnumero "
                            :aria-expanded="true"
                            role="button">
                        {{ localizedStringValue(tavoite.nimi) }}
                        <font-awesome-icon :icon="['fas', 'chevron-down']" class="trigger-icon" aria-hidden="true" role="presentation" />
                    </button>
                </h3>
                <div :id="rakenneElementit.length > 1 ? 'ho-goal-content-' + tavoite.jarjestysnumero : ''"
                     :class="[rakenneElementit.length > 1 ? 'ho-collapsible-content' : '', '']"
                     :aria-labelledby="rakenneElementit.length > 1 ? 'ho-goal-' + tavoite.jarjestysnumero : ''"
                     :aria-hidden="[rakenneElementit.length > 1 ? 'false' : '']"
                     role="region">
                    <ActionList :rakenne-elementti="tavoite"
                                :ministeriot="ministeriot"
                                :kohde-linkit="kohdeLinkit"
                                :kohteiden-linkit="kohteidenLinkit"
                                :liittyvat-kohde-uuids="liittyvatKohdeUuids"
                                :valitavoite-tyypit="valitavoiteTyypit"
                                :json-api="jsonApi"/>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import LocalizedStringService from "../services/localizedStringService";
    import ActionList from "./ActionList";
    import ElementIdService from "@/services/elementIdService";

    const localizedStringService = new LocalizedStringService();
    const elementIdService = new ElementIdService();

    export default {
        components: {ActionList},
        props: {
            rakenneElementit: Array,
            ministeriot: Array,
            kohdeLinkit: Object,
            kohteidenLinkit: Object,
            liittyvatKohdeUuids: Array,
            valitavoiteTyypit: Array,
            jsonApi: String
        },
        data: function() {
            return {
                localeState: "",
            }
        },
        beforeMount: function() {
            this.localeState = this.$translate.current;
        },
        computed: {
            filteredRakenneElementit() {
                if (this.rakenneElementit.length == 1) {
                    return this.rakenneElementit;
                } else {
                    return this.rakenneElementit.slice(1);
                }
            }
        },
        methods: {
            toggleCollapse() {
                let collapsibleTrigger = event.target;
                let collapsibleContent = event.target.parentNode.nextSibling;

                if (collapsibleContent.style.display === "none") {
                    collapsibleTrigger.setAttribute("aria-expanded", "true");
                    collapsibleTrigger.setAttribute("aria-label", this.$translate.text("close.menu"));
                    collapsibleTrigger.classList.remove('closed');
                    collapsibleTrigger.classList.add('opened');

                    collapsibleContent.style.display = "block";
                    collapsibleContent.setAttribute("aria-hidden", "false");
                } else {
                    collapsibleTrigger.setAttribute("aria-expanded", "false");
                    collapsibleTrigger.setAttribute("aria-label", this.$translate.text("open.menu"));
                    collapsibleTrigger.classList.remove('opened');
                    collapsibleTrigger.classList.add('closed');

                    collapsibleContent.style.display = "none";
                    collapsibleContent.setAttribute("aria-hidden", "true");
                }
            },
            localizedStringValue(localizedString) {
                return localizedStringService.getValue(localizedString, this.$translate.current);
            },
            generateIdFromElementti(elementti) {
              let name = this.localizedStringValue(elementti.nimi);
              return elementIdService.generateIdFromName(name);
            }
        }
    }
</script>

<style lang="scss">
    .aui .portlet-hankeikkuna-government-timeline, .portlet-hankeikkuna-government-timeline {

        $black : #222;
        $lightgray : #f0f0f0;
        $gray : #979797;
        $darkgray : #505050;
        $lightblue : #DFE7F5;
        $blue : #365abd;

        .ho-list-timeline {
            border-top: 1px solid $gray;

            &:first-child {
                border-top: 0;
            }

            .agenda2030-icons {
                .agenda2030-icon {
                  max-width: 120px;
                }
            }
        }

        .ho-collapsible {

            .objectiveList {

                .objectiveListItem {
                    padding: 15px;
                    border-bottom: 1px solid $gray;

                    &:last-child {
                        border: 0;
                    }
                }

                .typeIcon {
                    margin: 0 8px 0 0;
                    font-size: 16px;
                    color: $black;
                }

                .department-tag {
                    text-align: left;
                    white-space: normal;
                    margin: 0 5px 5px 0;
                    font-size: 11.75px !important;
                }

                .status-and-date  {
                    padding: 0 0 0 20px;
                    position: relative;
                    text-transform: uppercase;

                    .status {
                        display: inline-block;
                        margin: 0 5px 0 0;
                    }

                    .separator {
                        display: inline-block;
                        margin: 0 10px;
                        border: 0;
                    }

                    .date-icon {
                        position: absolute;
                        left: 0;
                        color: $black;
                        font-size: 16px;
                    }
                }

                .links {
                    a {
                        .external-link-icon {
                            font-size: 11px;
                            margin: 0 0 0 5px;
                        }
                    }
                }
            }
        }
    }
</style>